/*************************************************/
/* 3rd Party                                     */
/*************************************************/

// Passive event listeners
document.addEventListener('touchstart', () => { }, { passive: true });
document.addEventListener('touchmove', () => { }, { passive: true });

/*************************************************/
/* Partials                                      */
/*************************************************/

import { intersectionObservation } from "./partials/intersectionObservation.js";
import { gsapAnimations } from "./partials/gsapAnimations.js";
import { video } from "./partials/video.js";
import { modal } from "./partials/modal.js";
import { cookies } from "./partials/cookies.js";
import { lottieAnimation } from "./partials/lottieAnimations.js";
import { slider } from "./partials/slider.js";
import { menu } from "./partials/menuWebsite.js";
import { header } from "./partials/headerWebsite.js";
import { search } from "./partials/search.js";
import { searchbar } from "./partials/searchBar.js";
import { cards } from "./partials/cards.js";
import { employee } from "./partials/employee.js";
import { accordion } from "./partials/accordion.js";
import { accordionImages } from "./partials/accordion.js";
import { customCursor } from "./partials/customCursor.js";
import { anchorScroll } from "./partials/anchorScrollingWebsite.js";
import { vacancies } from "./partials/vacancies.js";
import { dropdown } from "./partials/language.js";
import { mobileMenu } from "./partials/mobileMenu.js";

/*************************************************/
/* Init                                          */
/*************************************************/

const ready = callback => {
    if (document.readyState != 'loading') callback();
    else document.addEventListener('DOMContentLoaded', callback);
}

ready(() => {
    const body = document.querySelector('body');
    const bodyLoadingClass = 'is-loading';

    // //Fire dataLayer event for forms submission - Figure out what dynamics uses
    // const formSubmitMessage = document.querySelector('[class^="submitButton"]');
    // console.log(formSubmitMessage, "her");
    // if (formSubmitMessage) {
    //     formSubmitMessage.addEventListener("click", e => {
    //         window.dataLayer.push({
    //             'event': 'formSubmission',
    //             'formType':formSubmitMessage.dataset.formName
    //         })
    //         console.log("push");
    //     });
    // }

    //Add click listener to skip link
    document.querySelector('#skipLink').addEventListener('click', e => {
        document.querySelector('#mainContent').focus();
    });

    intersectionObservation();
    gsapAnimations();
    modal(body, bodyLoadingClass);
    video();
    cookies();
    lottieAnimation();
    slider();
    menu();
    header(body);
    search();
    searchbar(body);
    cards();
    employee();
    accordion();
    accordionImages();
    customCursor();
    anchorScroll();
    vacancies();
    dropdown();
    mobileMenu();
});
